import React from 'react';
import BootcampTypeBannerLarge from './BootcampTypeBannerLarge.js';
import BootcampTypeBannerSmall from './BootcampTypeBannerSmall.js';
import { useMediaQueries } from '../../../utils/MediaQueries';

const BootcampTypeBanner = React.memo(({ isFullTimePage }) => {
  const mqs = useMediaQueries();
  return mqs.tabletLandscapeUp ? (
    <BootcampTypeBannerLarge isFullTimePage={isFullTimePage} />
  ) : (
    <BootcampTypeBannerSmall isFullTimePage={isFullTimePage} />
  );
});

export default BootcampTypeBanner;
